import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/leafletSafety";
import "@/utils/uiDensity";
import App from "@/App";
import { registrarServiceWorker } from "@/lib/serviceWorkerRegistration";

// ===== Suppressão do erro benigno "ResizeObserver loop" =====
// Radix (Sheet/Popover/DropdownMenu) e TanStack Table disparam esse loop.
// Fix definitivo: monkey-patch do ResizeObserver com callback debounced (rAF).
// Isso impede o loop de estourar antes que qualquer overlay (webpack-dev-server OU
// react-error-overlay) o capture. Solução usada por Ant Design, Radix e MUI.
if (typeof window !== "undefined" && typeof window.ResizeObserver !== "undefined") {
  const OriginalRO = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalRO {
    constructor(callback) {
      let scheduled = false;
      const debounced = (...args) => {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          // Se o callback do consumidor lançar, o erro propaga normalmente.
          callback(...args);
        });
      };
      super(debounced);
    }
  };
}

// Backup: também suprime via listener (caso o loop escape do debounce em algum edge case).
const RESIZE_OBSERVER_MSG = "ResizeObserver loop";
const isRO = (msg) => typeof msg === "string" && msg.includes(RESIZE_OBSERVER_MSG);
window.addEventListener("error", (e) => {
  if (isRO(e.message)) { e.stopImmediatePropagation(); e.preventDefault(); return false; }
}, true);
window.addEventListener("unhandledrejection", (e) => {
  const msg = e.reason?.message || String(e.reason || "");
  if (isRO(msg)) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

registrarServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
